__webpack_require__.p = "/pokemon-calculator/";